import React, { useState, Fragment, useEffect } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import {connect} from 'react-redux';
import toastMessageActions from 'jd-library/toastMessageActions';
import { updateBrandManufactureDetails } from '../../../../../actions/productSpecification';
import {handleOnChange} from '../../customActions';
import InputWithAutosuggestSlider from '../textboxAutosuggestContainer/InputWithAutosuggestSlider';
import styles from "./styles.scss";
import { addUpdateFixedSpecs, getProductSmartFillSpec } from '../../../../../actions/products';
import { debounceFunc } from '../../../../../common/Listing/utils';

const ManufacturerDetails = (props) => {
    const {
        editablePuvSpecAttributes,
        initPuvSpecAttributes,
        bMdetails,
        sendDetails,
        specification,
        showToastMessage,
        isMobile,
        isReadOnly,
        categoryChanged,
        allowCountryOriginChange
    } = props;

    /**
     *  Manufacturer Related Functions and Options
     *  onSubmitHandler, manufactureForm, handleManufacturerChange, sliderOptions, rightClickHandler
    */
   const [slider, toggleSlider] = useState(false);
   const [inputValue, setInputValue] = useState(null);
   const [mNameError, setmNameError] = useState('');
   const [mAddError, setmAddError] = useState('');

   const [mDetails, setMDetails] = useState({
       'manufacturer': "",
       'manufactured_details': ""
   });

   const inputNames = [
       'manufacturer',
       'manufactured_details'
   ];

    const manufactureForm = [
        {
            label: 'Manufacturer Name',
            holderClass: styles['manufacturer-input-text'],
            errorMessage: mNameError,
            className: props.compliance?.manufacturer && mDetails['manufacturer']?'disabled-input-bg':'',
            input: {
                value: mDetails[inputNames[0]],
                name: inputNames[0],
                type: 'text',
                onChange: (e) => { handleManufacturerChange(e) },
                onFocus:e=>setmNameError(''),
                autoComplete: "off",
                maxLength: 100
            },
            errClass:styles['error-class']
        },
        {
            label: "Manufacturer's Address/Contact Number",
            holderClass: styles['manufacturer-input-textarea'],
            className: props.compliance?.manufacturer && mDetails['manufactured_details']?'disabled-input-bg':'',
            errorMessage: mAddError,
            as: 'textarea',
            input:{
                value: mDetails[inputNames[1]],
                name: inputNames[1],
                onChange: (e) => handleManufacturerChange(e),
                onFocus:e=>setmAddError(''),
                autoComplete: "off",
                maxLength: 500,
                className: props.nonEditable ? 'disabled-input-bg' : '',
                style: { wordBreak: 'break-word' }
            }
        }
    ];

    const sliderOptions = {
        avoidPortal:"true",
        header: {
            heading: "Manufacturer Details",
            variant: "secondary",
            rightIcons: isMobile?  [] : [{
                className: 'icon-HDRcross',
                onClick: () => {
                    historyHandler.closeCurrent();
                }
            }],
            leftIcons: [{
                className: 'icon-HDRback',
                onClick: () => {
                    if(bMdetails.manufacturer != mDetails['manufacturer'] || bMdetails.manufactured_details != mDetails['manufactured_details']){
                        setmNameError('');
                        setmAddError('');
                        setMDetails({
                            manufacturer: bMdetails.manufacturer?bMdetails.manufacturer:mDetails['manufacturer'],
                            manufactured_details: bMdetails.manufactured_details?bMdetails.manufactured_details:mDetails['manufactured_details']
                        });
                    }
                    historyHandler.closeCurrent();
                }
            }]
        },
        onHidden : () => {
            toggleSlider(false);
            // props.resetSpecificationFormData();
        },
        footer: {
            btnProps: [{
                className: props.hasGlassFooter ? styles['ubl-btn'] : '',
                children: props.nonEditable ? 'Back' : 'Save',
                onClick: () => debouncedOnSubmitHandler()
            }]
        }
    }

    const handleManufacturerChange = (e) => {
        const {
            value,
            name,
        } = e.target;

        if(name == 'manufacturer' && value) {
            setmNameError('');
        }
        if(name == 'manufactured_details' && value) {
            setmAddError('');
        }
        setMDetails(prev => ({
            ...prev,
            [name]: value
        }));
    }

    // Removing manufacturing name on main input
    const clearManufacturerDetail = () => {
        if(isReadOnly){
            return;
        }
        if(inputValue) {
            const bmData = [...sendDetails];
            bmData.map(cur => {
                if(['manufacturer','manufactured_details'].includes(cur.name)) {
                    if(!props.compliance?.manufacturer){
                        cur.values = [];
                    }
                }
            })
            console.log(bmData);
            props.updateBrandManufactureDetails({
                [inputNames[0]]: props.compliance?.manufacturer?props.compliance.manufacturer:"",
                [inputNames[1]]: "",
                sendDetails: [...bmData]
            });
            setInputValue("");
            setMDetails({
                'manufacturer': props.compliance?.manufacturer?props.compliance.manufacturer:"",
                'manufactured_details': ""
            })
        }else {
            toggleSlider(!slider);
        }
    }

    const handleClickFooterBtn = () => {
        if (props.nonEditable) {
            historyHandler.closeCurrent()
        } else {
            onSubmitHandler()
        }
    }

    const onSubmitHandler = () => {
        let isUserInteracted = mDetails[inputNames[0]] || mDetails[inputNames[1]] 
        let error = '';
        if(isUserInteracted) {
            if(!mDetails[inputNames[1]]) {
                error = 'Please Enter Manufacturer’s Address/Contact Number';
                setmAddError('Please Enter Manufacturer’s Address/Contact Number');
            }else if(mDetails[inputNames[1]].length < 10) {
                error = 'Please Enter Valid Manufacturer’s Address/Contact Number';
                setmAddError('Please Enter Valid Manufacturer’s Address/Contact Number');
            }
    
            if(!mDetails[inputNames[0]] && !props.compliance?.manufacturer) {
                error = 'Please Enter Manufacturer Name';
                setmNameError('Please Enter Manufacturer Name');
            }else if(mDetails[inputNames[0]].length < 3) {
                error = 'Please Enter Valid Manufacturer Name';
                setmNameError('Please Enter Valid Manufacturer Name');
            }
        }

        if(error) {
            showToastMessage({ showToastMessage: true, message: error, type: (isMobile ? 'info' : 'error') });
        } else {
            let bmData = [...sendDetails];
            bmData.map((cur,index) => {
                if(['manufacturer','manufactured_details'].includes(cur.name)) {
                    cur.values = [mDetails[cur.name]];
                    let parentIndex = cur.name == 'manufacturer'?props.nameIndex:props.detailIndex;
                    let item = props.editablePuvSpecAttributes[parentIndex];
                    parentIndex && props.handleOnChange({e: {target:{value: cur.values[0]}}, parentIndex, item, key: "value",ignoreValidation: true})
                }
            })
            props.updateBrandManufactureDetails({
                brandName: brand,
                [inputNames[0]]: mDetails[inputNames[0]],
                [inputNames[1]]: mDetails[inputNames[1]],
                sendDetails: [...bmData]
            });
            setInputValue(mDetails[inputNames[0]]);
            historyHandler.closeCurrent();
        }

    }

    const debouncedOnSubmitHandler = debounceFunc(handleClickFooterBtn, 300);

    /**
     *  Brand Related Functions and Options
     *  removeBrandHandler, brandSubmitHandler
    */
   const [brandDetails, setBrandDetails] = useState({});
   const [brand, setBrand] = useState(null);
   const [isBrandPresent, setIsBrandPresent] = useState(false);
   const [isFocused,changeFocus] = useState(false);
   const [fixedAttributes,updateFixed] = useState({});
   const {
       s_type_options=[]
   } = brandDetails;

   const updateErrorsField = (key,value) => {
       let error = {...props.errors};
       error[key] = value;
       props.updateError(error);
   }
    const brandSubmitHandler = (value) => {
        let bmData = [...sendDetails];
        bmData[0] = {
            ...sendDetails[0],
            values: [value]
        };
        props.updateBrandManufactureDetails({
            ...bMdetails,
            brandDetails,
            brandName: value,
        sendDetails: [...bmData]
        });
        if(props.brandIndex) {
            props.handleOnChange({e: {target:{value}},parentIndex: props.brandIndex,item: props.editablePuvSpecAttributes[props.brandIndex],key: 'value',ignoreValidation: true})
        }
        setBrand(value);
        if(props.errors['brandName']){
            updateErrorsField('brandName','');
        }
        // props.setCategoryChanged();
        if(props.isAddProduct){
            props.getProductSmartFillSpec({
                brand: value,
                psv_node_id: props.psvNodeId,
                custom: !props.isTemplate
            });
        }
        allowCountryOriginChange();
        props.setBrandChange();
        // props.setCategoryChanged();
    }

    const removeBrandHandler = () => {
        if(!isReadOnly) {
            brandSubmitHandler('');
        }
    }

    useEffect(() => {
        let isBrandUpdated = false;
        const brandDet = editablePuvSpecAttributes.find(el => Number(el.s_id) === 122);
        let brandName = '';
        let prvBrand = categoryChanged && bMdetails?.brandDetails?.s_type != 'Fixed' && bMdetails.sendDetails.find(el => el.sid == '122').values?.length ? bMdetails.sendDetails.find(el => el.sid == '122').values[0]: '';
        if(editablePuvSpecAttributes.length) {
            if(brandDet) {
                setBrandDetails(brandDet);
                let bmData = [...sendDetails];
                if(brandDet.userInput.value){
                    brandName = categoryChanged ? '' : brandDet.userInput.value;
                    setBrand(brandDet.userInput.value);
                }else {
                    brandName = (Array.isArray(brandDet.s_type_options) && brandDet.s_type_options[0]) || prvBrand;
                    bmData[0] = {
                        ...sendDetails[0],
                        values: brandDet.s_type == 'Fixed'?[brandDet.s_type_options[0]]:[prvBrand]
                    };
                    if(brandDet.s_type == 'Fixed'){
                        updateFixed({...fixedAttributes,brand: true})
                        setBrand(brandName);
                        isBrandUpdated = true;
                        if(props.isAddProduct){
                            props.getProductSmartFillSpec({
                                brand: brandName,
                                psv_node_id: props.psvNodeId,
                                custom: !props.isTemplate
                            });
                        }
                    }else {
                        updateFixed({...fixedAttributes,brand: false})
                        setBrand(prvBrand);
                        isBrandUpdated = true;
                    }
                }
                props.updateBrandManufactureDetails({
                    ...bMdetails,
                    brandDetails,
                    brandName,
                sendDetails: [...bmData]
                });
            }
        }

        if(bMdetails.brandName && !isBrandUpdated) {
            setBrand( categoryChanged ? prvBrand : bMdetails.brandName);
        }else if(props.brandChange){
            setBrand(brandDet?.s_type == 'Fixed'?brandDet.s_type_options[0]:bMdetails?.brandName?bMdetails?.brandName:brandName)
            props.setBrandChange();
        }

        // if(bMdetails.manufacturer || (props.compliance && !editablePuvSpecAttributes.find(el => el.s_nm == 'manufacturer'))) {
            if(bMdetails.manufacturer || bMdetails.manufactured_details){
            setMDetails({
                manufacturer: bMdetails.manufacturer?bMdetails.manufacturer:mDetails['manufacturer'],
                manufactured_details: bMdetails.manufactured_details?bMdetails.manufactured_details:mDetails['manufactured_details']
            });
            setInputValue(bMdetails.manufacturer);
        }

    }, [editablePuvSpecAttributes,bMdetails.manufacturer,bMdetails.manufactured_details]);

    useEffect(() => {
        if(props.brandSuggestion?.length){
            setIsBrandPresent(true);
        }
    },[props.brandSuggestion])

    useEffect(() => {
        if(props.compliance?.manufacturer && mDetails['manufacturer']){
            props.addUpdateFixedSpecs({
                dataToAdd: '3848'
            })
        }
        if(brand){
            props.addUpdateFixedSpecs({
                dataToAdd: '122'
            })
        }
    },[props.compliance])
    let manufacturerName = inputValue;
    if(props.compliance?.manufacturer && !mDetails['manufactured_details']) {
        manufacturerName = '';
    }
    let isPending = props.isTemplate && (mDetails['manufacturer'] && mDetails['manufactured_details']) && !(props.compliance?.manufacturer && props.compliance?.manufactured_details);
    return (<Fragment>
            {!props.isTemplate && !props?.isEnrichSpec?
            <>
            {isBrandPresent ? <InputWithAutosuggestSlider
                    sliderHeading={'Brand'}
                    key='brand-122'
                    label="Brand"
                    input={{
                        value: brand,
                        type: 'text',
                        name: 'brand-122',
                        autoFocus: false,
                        onChange: (e) => { console.log(e); },
                        readOnly: true
                    }}
                    suggestions={props.brandSuggestion.length ? props.brandSuggestion.map((s_item, s_index)=> {
                        return {key: s_index ,value: s_item }
                    }) : []}
                    onSelect={(res) => brandSubmitHandler(res.value)}
                    onRightIconClick={removeBrandHandler}
                    className={`${(brand) ? 'disabled-input-bg ' : ''} ${isReadOnly? 'read-only-mode':''}`}
                    showOutSideFields={false}
                    errorMessage={props.errors['brandName']}
                    fromBrand={true}
                    ignoreIcon={fixedAttributes['brand']}
                /> : <InputWithMovingLabel
                        label="Brand"
                        input={{
                            value: brand,
                            autoFocus: false,
                            onChange: (e) => brandSubmitHandler(e.target.value),
                            onFocus: () => {
                                changeFocus(true);
                                if(props.errors['brandName']){
                                    updateErrorsField('brandName','');
                                }
                            },
                            onBlur: () => changeFocus(false)
                        }}
                        className={brand && !isFocused ? 'disabled-input-bg ' : ''}
                        onRightIconClick={removeBrandHandler}
                        // rightIconClass={brand && !isFocused ? "icon-HDRcross" : ""}
                        rightIconClass={''}
                        holderClass={`${styles['manufacturer-input-text']}  ${isReadOnly ? " read-only-mode" : "" } `}
                        errorMessage={props.errors['brandName']}
                    />}
            </>
            :null}
            <InputWithMovingLabel
                label="Manufacturer Details"
                input={{
                    value: manufacturerName,
                    onClick: () => toggleSlider(props.nonEditable ? false : !slider),
                    onFocus: () => {
                        if(props.errors['manufacturerDetails']){
                            updateErrorsField('manufacturerDetails','');
                        }
                    },
                    readOnly: true,
                    autoFocus: false
                }}
                className={``}
                onRightIconClick={() => toggleSlider(!slider)}
                rightIconClass={"icon-Next"}
                errorMessage={props.errors['manufacturerDetails']}
                holderClass={`${styles['manufacturer-input-text']} ${styles['hand-pointer']} ${isReadOnly ? " read-only-mode" : "" }`}
            />
            {slider ? <SliderWrapper {...sliderOptions}>
                <div className={styles['manufacturer-details-section']}>
                    {manufactureForm.map((element) => <InputWithMovingLabel {...element} />)}
                </div>
            </SliderWrapper> : null}
    </Fragment>);
}

const mapStateToProps = (state, props) => {
    let editablePuvSpecAttributes = state.productSpecification.editablePuvSpecAttributes;
    let nameIndex = '';
    let detailIndex = '';
    let brandIndex = '';
    editablePuvSpecAttributes.map((cur,index) => {
        if(cur.s_nm == 'manufacturer'){
            nameIndex = index;
        }
        if(cur.s_nm == 'manufactured_details'){
            detailIndex = index;
        }
        if(cur.s_id == 122 || cur.s_id == '122'){
            brandIndex = index;
        }
    });

    return {
        ...props,
        editablePuvSpecAttributes,
        nameIndex,
        detailIndex,
        brandIndex,
        specification: state.products.editProduct?.specification,
        isEnrichSpec: state.productSpecification?.isEnrichSpec,
        compliance: state.products.editProduct?.compliance,
        bMdetails: state.brandManufacturer,
        sendDetails: state.brandManufacturer.sendDetails,
        brandSuggestion: state.products.brandSuggestion,
        productSmartFillSpec: state.productSpecification.productSmartFillSpec,
        isSellOnline: state.products.editProduct?.isSellOnline,
        hasGlassFooter: state.session.hasGlassFooter
    }
};

const mapDispatchToProps = (dispatch) => ({
    updateBrandManufactureDetails: (payload) => dispatch(updateBrandManufactureDetails(payload)),
    showToastMessage: (payload) => dispatch(toastMessageActions.showMessage(payload)),
    handleOnChange: (options) =>  handleOnChange(options, dispatch),
    getProductSmartFillSpec: payload  => dispatch(getProductSmartFillSpec(payload)),
    addUpdateFixedSpecs: payload => dispatch(addUpdateFixedSpecs(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManufacturerDetails);
